import { render, staticRenderFns } from "./WizardDone.vue?vue&type=template&id=4e3c31ea&scoped=true&"
import script from "./WizardDone.vue?vue&type=script&lang=js&"
export * from "./WizardDone.vue?vue&type=script&lang=js&"
import style0 from "./WizardDone.vue?vue&type=style&index=0&id=4e3c31ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3c31ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
